import { omitBy } from 'fxjs/es';
import axios from 'axios';

export async function computeShippingCostF(args) {
  const params = omitBy(([_, v]) => v === undefined, args);
  const { shipping_cost } = (await axios.get('/@api/shipping_cost', { params })).data;
  return shipping_cost;
}
